import { ColumnProps } from '../../duck';
import {
  Tbody as ChakraTBody,
  Checkbox,
  Spinner,
  TableBodyProps,
  Td,
  Tr,
} from '@chakra-ui/react';
import { get } from 'lodash-es';
import React from 'react';

interface TBodyProps extends TableBodyProps {
  data: any[];
  columns: ColumnProps[];
  onRowSelect?: (id: string | number) => void;
  selectedRows: (string | number)[];
  loading?: boolean;
}

const TBody: React.FC<TBodyProps> = ({
  data,
  columns,
  onRowSelect,
  selectedRows,
  loading,
  ...rest
}) => {
  return (
    <ChakraTBody {...rest}>
      {data.length > 0 ? (
        data.map((record, index) => {
          const isRowSelected =
            onRowSelect && selectedRows.includes(record.id || record._id);
          return (
            <Tr
              position="relative"
              key={index}
              borderBottom="1px solid #EDF2F7"
            >
              {onRowSelect && (
                <Td w="14" pl="6" pr="3">
                  <Checkbox
                    colorScheme="dark"
                    borderColor="dark.500"
                    onChange={() => {
                      onRowSelect(record._id || record.id);
                    }}
                    isChecked={isRowSelected}
                  />
                </Td>
              )}
              {columns.map((column, i) => {
                const value = get(record, column.dataKey || '');
                return (
                  <Td
                    key={i}
                    height="0"
                    px={6}
                    py={4}
                    bgColor="white"
                    borderRight="none"
                    borderLeft="none"
                    boxShadow="none"
                    w={column.w}
                  >
                    {column.render
                      ? column.render(value, record, index)
                      : value}
                  </Td>
                );
              })}
            </Tr>
          );
        })
      ) : loading ? (
        <Tr>
          <Td colSpan={columns.length} textAlign="center">
            <Spinner />
          </Td>
        </Tr>
      ) : (
        <Tr>
          <Td colSpan={columns.length} textAlign="center">
            No Data
          </Td>
        </Tr>
      )}
    </ChakraTBody>
  );
};

export default TBody;
